"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Survicate_1 = require("configs/Survicate");
const translationContext_1 = require("configs/translationContext");
const mobx_react_1 = require("mobx-react");
const constants_1 = require("modules/app/services/datahub/constants");
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
const helper_1 = require("modules/app/services/datahub/helper");
const featureToggle_1 = require("modules/featureToggle");
const mapStateToProps = () => ({
    isSurveyEnabled: featureToggle_1.FeatureToggleService.isEnabled(featureToggle_1.FeatureToggles.SurveyThirdyProducts)
});
const SurveyProducts = ({ isSurveyEnabled }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const openSurvey = () => {
        (0, Survicate_1.showSurvey)(Survicate_1.SURVEY_ID_LIST.SURVEY_THIRDY_PRODUCTS, {
            forceDisplay: true
        });
        DatahubService_1.default.sendEvent({
            action: constants_1.EVENT_ACTIONS.INTERACT,
            event: (0, helper_1.buildInteractionEventData)({
                category: constants_1.EVENTS_CATEGORY.CLICK_SURVEY_THIRDY_PRODUCTS,
                action: constants_1.EVENTS_INTERACTIONS.CLICK,
                label: 'Survey'
            })
        });
    };
    if (!isSurveyEnabled) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: openSurvey, className: "_d-flex _justify-content-end _w-full _py-4 _text-blue", children: t('dashboard.navigation_card.club_sales.thirdy_products') }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(SurveyProducts);
